module.exports = __webpack_public_path__ + "static/media/views.28447198.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/slides/LastProjects/components/BehancePreview/assets/views.svg
// module id = 48
// module chunks = 0